<template>
  <div class="home" style="text-align: left">
    <el-row :gutter="40">
      <el-col :span="12" :xs="24"
        ><div class="">
          <h3 style="margin-bottom: 20px; margin-top: 12px">
            NETWORK PERFORMANCE
          </h3>
          <el-row
            style="text-align: center"
            :gutter="20"
            v-loading="loading"
            class="dashboardBlock"
          >
            <el-col
              :span="6"
              :xs="12"
              :sm="12"
              :md="6"
              style="position: relative"
            >
              <span>Pupils registered</span><br />
              <el-progress
                type="circle"
                :percentage="school.total_parents / stats.parents"
                :textInside="true"
                :width="110"
                :stroke-width="12"
                color="#4198AF"
              ></el-progress>
              <div class="progressText" style="color: #4198af">
                {{ Math.round((school.total_parents / stats.parents) * 100)
                }}<br />
                Pupils
              </div>
            </el-col>
            <el-col
              :span="6"
              :xs="12"
              :sm="12"
              :md="6"
              style="position: relative"
            >
              <span>Staff registered</span><br />
              <el-progress
                type="circle"
                :percentage="(school.total_staff / stats.staff) * 100"
                :width="110"
                :stroke-width="12"
                :textInside="true"
                color="#89a54e"
              ></el-progress>
              <div class="progressText" style="color: #89a54e">
                {{ Math.round((school.total_staff / stats.staff) * 100) }}<br />
                Staff
              </div>
            </el-col>
            <el-col
              :span="6"
              :xs="12"
              :sm="12"
              :md="6"
              style="position: relative"
            >
              <span>Sustainable Travel</span><br />
              <el-progress
                type="circle"
                :percentage="
                  (stats.journeys_sustainable / stats.journeys) * 100
                "
                :width="110"
                :stroke-width="12"
                :textInside="true"
                color="#15b1db"
              ></el-progress>
              <div class="progressText" style="color: #15b1db">
                {{
                  Math.round(
                    (stats.journeys_sustainable / stats.journeys) * 100
                  )
                }}%<br />
                Journeys
              </div>
            </el-col>
            <el-col
              :span="6"
              :xs="12"
              :sm="12"
              :md="6"
              style="position: relative"
            >
              <span>Active Travel</span><br />
              <el-progress
                type="circle"
                :percentage="(stats.journeys_active / stats.journeys) * 100"
                :width="110"
                :stroke-width="12"
                :textInside="true"
                color="#787878"
              ></el-progress>
              <div class="progressText" style="color: #787878">
                {{
                  Math.round((stats.journeys_active / stats.journeys) * 100)
                }}%<br />
                Journeys
              </div>
            </el-col>
          </el-row>
          <h3 style="margin-bottom: 0px; margin-top: 12px">
            KEY TASKS & GUIDES
          </h3>
          <el-row
            :gutter="20"
            class="dashboardBlock"
            style="padding-bottom: 0px"
          >
            <el-col :span="24">
              <div class="">
                <h4 style="margin-bottom: 20px; margin-top: 0px; color: navy">
                  Sign up parents and staff
                </h4>
                <p style="font-size: 12px" class="grayText">
                  Share these links with parents and staff regulary to increase
                  your sign up rate.
                </p>
                <div style="font-size: 12px">
                  <span
                    class="grayText"
                    style="
                      padding-left: 20px;
                      display: inline-block;
                      width: 70px;
                    "
                    >Parent link:</span
                  ><span class="hrLink"
                    >https://{{ domain }}/welcome/{{ school.code }}</span
                  >
                  <button
                    type="button"
                    style="background: none; border: 0; color: #007899"
                    v-clipboard:copy="
                      'https://user.homerun-app.com/welcome/testp'
                    "
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  >
                    <i class="far fa-copy"></i></button
                  ><br /><br />
                  <span
                    class="grayText"
                    style="
                      padding-left: 20px;
                      display: inline-block;
                      width: 70px;
                    "
                    >Staff link:</span
                  ><span class="hrLink"
                    >https://{{ domain }}/welcome/{{ school.staff_code }}</span
                  >
                  <button
                    type="button"
                    style="background: none; border: 0; color: #007899"
                    v-clipboard:copy="
                      'https://user.homerun-app.com/welcome/tests'
                    "
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  >
                    <i class="far fa-copy"></i></button
                  ><br /><br />
                </div>
                <div class="bottom">
                  <a href=""
                    ><i class="far fa-circle-play"></i> Watch tutorial</a
                  >
                  <a href="">Parent email template</a>
                  <a href="">Staff email template</a>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row
            :gutter="20"
            :key="item.id"
            class="dashboardBlock"
            style="padding-bottom: 0px"
            v-for="item in guides"
          >
            <el-col :span="24">
              <div class="">
                <h4 style="margin-bottom: 20px; margin-top: 0px; color: navy">
                  {{ item.title }}
                </h4>
                <p style="font-size: 12px" class="grayText">
                  {{ item.text }}
                </p>
                <div class="bottom">
                  <a v-if="item.link" :href="item.link">{{ item.linkLabel }}</a>
                  <a v-if="item.link2" :href="item.link2">{{
                    item.link2Label
                  }}</a>
                  <a v-if="item.link3" :href="item.link3">{{
                    item.link3Label
                  }}</a>
                </div>
              </div>
            </el-col>
          </el-row>
        </div></el-col
      >
      <el-col :span="8" :xs="24"
        ><div class="">
          <h3 style="margin-bottom: 0px; margin-top: 12px">
            TARGETS & ACHIEVEMENTS
          </h3>
          <AchievementsSection
            v-if="achievements.length > 0"
            :achievements="achievements"
            :completedAchievements="completedAchievements"
            :totalAchievements="totalAchievements"
            class="dashboardBlock"
          /></div
      ></el-col>
    </el-row>
  </div>
</template>

<script>
import AchievementsSection from "@/components/dashboard/AchievementsSection.vue";
import ApiService from "@/services/ApiService";

export default {
  name: "Homev2",
  components: {
    AchievementsSection,
  },
  data() {
    return {
      loading: false,
      totalAchievements: 2,
      completedAchievements: 1,
      items: [
        {
          category: "test",
          goalText: "Submit your t4x return",
          description: "You have to submit by deadline",
          link: "https://dog.com",
          ctaLabel: "Dogs",
          goalValue: 1,
        },
        {
          category: "test",
          goalText: "Add 10 parents",
          description: "You have to submit by deadline",
          route: "stuff",
          ctaLabel: "Dogs",
          goalValue: 4,
        },
      ],
      achievements: [],
      school: { code: "", staff_code: "" },
      domain: window.location.hostname,
      guides: [],
      stats: {},
    };
  },
  methods: {
    goto(route) {
      if (route == "Travel Plan Maps") {
        this.$router.push({
          name: "Travel Plan Maps",
          params: { category: "modes_of_travel_map" },
        });
      } else {
        this.$router.push({ name: route });
      }
    },
    onCopy() {
      this.$notify.success({
        title: "Success",
        message: "Succesfully copied!",
      });
    },
    onError() {
      this.$notify.error({
        title: "Failed",
        message: "Failed to copy!",
      });
    },
  },
  computed: {
    accType: function () {
      return this.$store.state.user.admin_type.name;
    },
  },
  mounted() {
    ApiService.generalApi.getDashboardHome().then((resp) => {
      let completed = 0;
      let total = 0;
      const achievements = resp.data.achievements;
      this.school = resp.data.school;
      this.stats = resp.data.school_stats;
      this.guides = resp.data.guides;
      try {
        achievements.forEach((achievement) => {
          total += achievement.levels.length;

          achievement.levels.sort((a, b) =>
            a.goalValue < b.goalValue ? -1 : 1
          );
          let breakLoop = false;
          let finished = true;
          let levelsCompleted = 0;
          achievement.levels.forEach((level) => {
            if (level.goalValue <= achievement.currentValue) {
              completed += 1;
              levelsCompleted += 1;
            } else if (!breakLoop) {
              finished = false;
              if (level.goalText) {
                achievement.goalText = level.goalText;
              }
              achievement.goalValue = level.goalValue;
              breakLoop = true;
            }
          });

          if (finished) {
            achievement.completed = true;
            achievement.progress = 100;
          } else {
            achievement.completed = false;
            achievement.progress = parseInt(
              (levelsCompleted / achievement.levels.length) * 100
            );
          }
        });
      } catch (error) {
        alert(error);
      }
      this.achievements = achievements.sort((a, b) => {
        return +a.completed - +b.completed;
      });
      this.totalAchievements = total;
      this.completedAchievements = completed;
    });
  },
};
</script>
<style scoped>
.tallblock {
  margin-top: 5px;
  padding-bottom: 5px;
  padding-right: 5px;
  /* background: blue; */
}
.smblock {
  height: 250px;
  padding: 5px;
}
.singlebtn {
  /* background: red; */
  height: 100%;
  min-height: 300px;
  width: 220px;
  border-radius: 5px;
  position: relative;
  transition: all 0.4s;
  display: inline-block;
  padding-top: 20px;
  text-align: center;
  margin-right: 10px;
  /* filter: grayscale(50%); */
  /* border: 1px solid #ffffff; */
}
.singlebtn:hover {
  opacity: 0.9;
  /* border: 1px solid #8a8a8a; */
  /* filter: grayscale(0%); */
}
.singlebtn div {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  width: 95%;
  padding: 10px;
  cursor: pointer;
}
.singlebtn .inside .icon {
  font-size: 70px;
  height: 50px;
  margin-bottom: 35px;
  opacity: 0.5;
}
.singlebtn .inside span {
  display: block;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 15px;
  height: 50px;
}
.singlebtn .inside hr {
  opacity: 0.5;
  margin-right: 10px;
  margin-left: 10px;
  background-color: white;
}
.singlebtn .inside p {
  display: block;
  font-size: 13px;
  opacity: 0.8;
  min-height: 70px;
}
.statsBlock {
  background: #f9f9f9f9;
  padding: 5px;
  display: block;
  border-radius: 5px;
  margin-top: 20px;
  box-shadow: 0px 0px 10px #dddddd;
}
.dashboardBlock {
  background: white;
  border: 1px solid #ccc;
  padding: 20px;
  margin-top: 20px;
}
.dashboardBlock .bottom {
  border-top: 1px solid #ddd;
  text-align: center;
}
.dashboardBlock .bottom a {
  display: inline-block;
  text-decoration: none;
  min-width: 150px;
  font-size: 12px;
  color: #15b1db;
  font-weight: 500;
  line-height: 3em;
}
.progressText {
  height: 60px;
  position: absolute;
  top: 45px;
  text-align: center;
  width: 100%;
  margin-left: -10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  line-height: 14px;
}
.grayText {
  color: #8f8f8f;
}
.hrLink {
  color: #222;
}
</style>
